/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages, useIntl, FormattedMessage} from 'react-intl';
import {ButtonToolbar, Modal} from 'react-bootstrap';
import GoToCartButton from 'components/form/button/GoToCartButton';
import DismissButton from 'components/form/button/DismissButton';

const messages = defineMessages({
  confirm: {id: 'button.confirm'},
});

const CheckoutModal = ({show, title, goToCart, onCancel, children}) => {
  const intl = useIntl();

  return (
    <Modal show={show} backdrop="static" keyboard={false} onHide={onCancel}>
      <Modal.Header
        closeButton={false}
        closeLabel={intl.formatMessage(messages.confirm)}
      >
        <Modal.Title>
          <FormattedMessage {...title} />
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>{children}</Modal.Body>

      <Modal.Footer>
        <ButtonToolbar>
          <GoToCartButton onClick={goToCart} />
          <DismissButton className="ml-2" onClick={onCancel} />
        </ButtonToolbar>
      </Modal.Footer>
    </Modal>
  );
};

export default CheckoutModal;
